import { TranslatePipe } from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";

import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
  selector: "forti-analyzer-item",
  templateUrl: "forti-analyzer-item.html",
  styleUrls: ["../../shortcut-menu.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslatePipe, AngularSvgIconModule],
})
export class FortiAnalyzerItem {}
